export default __webpack_public_path__ + "static/media/AdamSpizak4ETHM.95c44509.mp4";